import React from "react";
import Lottie from "lottie-react";
import graffitiAnimation from "../../assets/lottie/grafitti.json";

const Graffiti = () => {
  return (
    // <div className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none">
    //   <div className="text-4xl font-bold animate-bounce">
    //     🎉 Coupon Applied!
    //   </div>
    // </div>
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-50">
      <Lottie
        animationData={graffitiAnimation}
        loop={false}
        autoplay={true}
        style={{ width: "100%", height: "auto" }}
      />
    </div>
  );
};

export default Graffiti;
